import {
  Avatar,
  Card,
  CardContent,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ButtonWithPermissions from '../../../components/buttonWithPermissions/buttonWithPermissions'
import { styles } from './announcementListItem.styles'

export interface AnnouncementListItemProps {
  emptyMessage?: string
  listIsEmpty?: boolean
  avatarText: string
  primaryText: string
  secondaryText: string
  actionText: string
  hasPermission?: boolean
  itemType?: number
  onClickHandler?: (itemType: number) => void
}

const AnnouncementListItem: React.FC<AnnouncementListItemProps> = ({
  emptyMessage,
  listIsEmpty = false,
  avatarText,
  primaryText,
  secondaryText,
  actionText,
  hasPermission = true,
  itemType = 0,
  onClickHandler
}) => {
  const [t] = useTranslation(['globalerisLibrary'])

  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  const mobile = useMediaQuery(currentTheme.breakpoints.down('xs'))
  const responsive = useMediaQuery(currentTheme.breakpoints.down('sm'))

  return (
    <ListItem>
      {listIsEmpty ? (
        <ListItemText
          secondary={emptyMessage}
          secondaryTypographyProps={{
            style: { wordWrap: 'break-word', textAlign: responsive ? 'center' : 'left' }
          }}
        />
      ) : (
        <Card style={{ width: '100%' }}>
          <CardContent
            className={classes.cardAnnouncement}
            style={{
              display: 'flex',
              flexDirection: responsive ? 'column' : 'row',
              justifyContent: responsive ? 'center' : 'space-between'
            }}
          >
            <ListItem>
              {!mobile ? (
                <ListItemAvatar>
                  <Avatar>{avatarText}</Avatar>
                </ListItemAvatar>
              ) : null}

              <ListItemText
                primary={primaryText}
                secondary={secondaryText}
                secondaryTypographyProps={{ style: { wordWrap: 'break-word' } }}
                style={{ justifyContent: responsive ? 'center' : 'flex-start' }}
              />
            </ListItem>
            <ListItem
              style={{
                alignItems: responsive ? 'center' : 'flex-end',
                justifyContent: responsive ? 'center' : 'flex-end'
              }}
            >
              {hasPermission ? (
                <ButtonWithPermissions
                  onClick={() => onClickHandler && onClickHandler(itemType)}
                  size="small"
                  color="primary"
                  hasPermission={hasPermission}
                  className={classes.actionAnnouncement}
                >
                  {actionText}
                </ButtonWithPermissions>
              ) : null}
            </ListItem>
          </CardContent>
        </Card>
      )}
    </ListItem>
  )
}

export default AnnouncementListItem
